// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCtYKsT-CJgqVzal1OIs-L9Y4RJEwWUHkg",
  authDomain: "fightgo-953ee.firebaseapp.com",
  projectId: "fightgo-953ee",
  storageBucket: "fightgo-953ee.firebasestorage.app",
  messagingSenderId: "704379233360",
  appId: "1:704379233360:web:1dd25849647ca947795d55",
  measurementId: "G-FXMN9ZFZQX",
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);
const firebaseAnalytics = getAnalytics(firebaseApp);

export { firebaseApp, firebaseAnalytics };
